import React from 'react';
import { Link } from 'react-router-dom';
import { isStudent, isAuthenticated } from '../utils/auth';
import './Home.css';

function Home() {
  const loggedIn = isAuthenticated();
  const showStudentRegister = !loggedIn && !isStudent();
  const testimonials = [
    {
      id: 1,
      text: "CampusRecruit helped me find my dream job at a top tech company. The platform made the entire process smooth and efficient.",
      name: "Rahul Kumar",
      role: "Software Engineer at Tech Solutions",
      avatar: "RK"
    },
    {
      id: 2,
      text: "As a company, we found exceptional talent through this platform. The quality of candidates is outstanding.",
      name: "Priya Mehta",
      role: "HR Manager at Global Systems",
      avatar: "PM"
    },
    {
      id: 3,
      text: "The placement drives are well-organized and the application process is straightforward. Highly recommended!",
      name: "Anjali Sharma",
      role: "Data Analyst at Digital Innovations",
      avatar: "AS"
    }
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Welcome to CampusRecruit</h1>
          <p>Connecting Students with Top Companies</p>
          <p className="hero-subtitle">Your Gateway to Career Success</p>
          <div className="hero-buttons">
            {showStudentRegister && <Link to="/student-register" className="btn btn-primary">Register as Student</Link>}
            {!loggedIn && <Link to="/company-register" className="btn btn-secondary">Register as Company</Link>}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">Why Choose Us?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>Targeted Placements</h3>
              <p>Connect with companies that match your skills and career goals</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🏢</div>
              <h3>Top Companies</h3>
              <p>Access to leading companies across various industries</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📚</div>
              <h3>College Network</h3>
              <p>Extensive network of colleges and universities</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Quick Process</h3>
              <p>Streamlined recruitment process for faster placements</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h3>500+</h3>
              <p>Companies</p>
            </div>
            <div className="stat-item">
              <h3>1000+</h3>
              <p>Colleges</p>
            </div>
            <div className="stat-item">
              <h3>50,000+</h3>
              <p>Students</p>
            </div>
            <div className="stat-item">
              <h3>10,000+</h3>
              <p>Placements</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <div className="container">
          <h2 className="section-title">How It Works</h2>
          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">1</div>
              <h3>Create Your Profile</h3>
              <p>Register as a student and build your professional profile with your skills, education, and experience.</p>
            </div>
            <div className="step-card">
              <div className="step-number">2</div>
              <h3>Browse Placement Drives</h3>
              <p>Explore various placement drives from top companies and find opportunities that match your interests.</p>
            </div>
            <div className="step-card">
              <div className="step-number">3</div>
              <h3>Apply for Vacancies</h3>
              <p>Apply for multiple positions within a drive by uploading your resume and completing the application.</p>
            </div>
            <div className="step-card">
              <div className="step-number">4</div>
              <h3>Get Placed</h3>
              <p>Attend interviews and get selected by your dream company to kickstart your career journey.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <div className="container">
          <h2 className="section-title">Success Stories</h2>
          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="testimonial-content">
                  <p>"{testimonial.text}"</p>
                </div>
                <div className="testimonial-author">
                  <div className="author-avatar">{testimonial.avatar}</div>
                  <div className="author-info">
                    <h4>{testimonial.name}</h4>
                    <p>{testimonial.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Recent Drives Section */}
      <section className="recent-drives">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Upcoming Placement Drives</h2>
            <Link to="/placement-drives" className="view-all-link">View All →</Link>
          </div>
          <div className="drives-preview">
            <div className="drive-preview-card">
              <div className="drive-preview-image">🏢</div>
              <div className="drive-preview-content">
                <h3>Tech Solutions Inc. Drive</h3>
                <p>📍 Bangalore | 📅 March 15, 2024</p>
                <p className="drive-preview-desc">Multiple positions available for Software Engineers, Data Analysts, and more.</p>
                <Link to="/placement-drives" className="drive-preview-link">Learn More →</Link>
              </div>
            </div>
            <div className="drive-preview-card">
              <div className="drive-preview-image">💼</div>
              <div className="drive-preview-content">
                <h3>Global Systems Recruitment</h3>
                <p>📍 Mumbai | 📅 March 20, 2024</p>
                <p className="drive-preview-desc">Exciting opportunities in consulting and business analysis roles.</p>
                <Link to="/placement-drives" className="drive-preview-link">Learn More →</Link>
              </div>
            </div>
            <div className="drive-preview-card">
              <div className="drive-preview-image">🚀</div>
              <div className="drive-preview-content">
                <h3>Digital Innovations Pool Drive</h3>
                <p>📍 Hyderabad | 📅 March 25, 2024</p>
                <p className="drive-preview-desc">Full stack developers, AI engineers, and cloud specialists needed.</p>
                <Link to="/placement-drives" className="drive-preview-link">Learn More →</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      {!loggedIn && (
        <section className="cta">
          <div className="container">
            <h2>Ready to Start Your Career Journey?</h2>
            <p>Join thousands of students and companies already on our platform</p>
            <div className="cta-buttons">
              <Link to="/student-register" className="btn btn-primary btn-large">Register as Student</Link>
              <Link to="/company-register" className="btn btn-secondary btn-large">Register as Company</Link>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default Home;

